const ROOT_PAGE_ID = "rootPage";

export type NavigationLayoutState = "pinned" | "unpinned";

const getRootPage = (): HTMLElement | null => document.getElementById(ROOT_PAGE_ID);

export const updateNavigationLayoutState = (state: NavigationLayoutState | null): void => {
  const rootPage = getRootPage();

  if (!rootPage) {
    return;
  }

  if (state === null) {
    rootPage.removeAttribute("data-navigation-state");
    return;
  }

  rootPage.dataset.navigationState = state;
};
